import { render } from "./OrderPopover.vue?vue&type=template&id=98b57c0c&scoped=true"
import script from "./OrderPopover.vue?vue&type=script&lang=js"
export * from "./OrderPopover.vue?vue&type=script&lang=js"

import "./OrderPopover.vue?vue&type=style&index=0&id=98b57c0c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-98b57c0c"

export default script